import React, {useRef} from 'react';
import {ButtonGroup, Dropdown, DropdownButton} from "react-bootstrap";
import {faEdit, faGear} from "@fortawesome/free-solid-svg-icons";
import IconButton from "../IconButton";
import {useSelector} from "react-redux";
import {selectLang} from "../../store/reducers/main/main";
import {Translate} from "../../lang/lang";
import {Link} from "react-router-dom";
import EditBulkItemsModal from "../item/components/EditBulkItemsModal";
import BulkItemRevision from "../item/components/BulkItemRevision";
import SelectBulkCatalogButton from "../item/components/SelectBulkCatalogButton";
import BulkDeleteItems from "../item/components/BulkDeleteItems";
import BulkEditItemLegalType from "../item/components/BulkEditItemLegalType";

const MassCommonButtonDropdown = ({selectedItems}) => {
    const lang = useSelector(selectLang);
    const t = Translate;
    return (
        <ButtonGroup>
            <IconButton
                variant="phoenix-primary"
                icon={faEdit}
                size="sm"
                className={"btn-davr px-3 py-0 bg-primary-davr text-white"}
            >
                {t(lang, 'items.common.bulk_edit.button')}
            </IconButton>
            <DropdownButton className="border-left-0 btn-davr px-0 bg-primary-davr text-white" variant="falcon-default" as={ButtonGroup} title="" id="bg-nested-dropdown">
                <Dropdown.Item>
                    <EditBulkItemsModal items={selectedItems}/>
                </Dropdown.Item>
                <Dropdown.Item>
                    <BulkItemRevision items={selectedItems}/>
                </Dropdown.Item>
                <Dropdown.Item>
                    <SelectBulkCatalogButton items={selectedItems}/>
                </Dropdown.Item>
                <Dropdown.Item>
                    <BulkEditItemLegalType items={selectedItems}/>
                </Dropdown.Item>
            </DropdownButton>
        </ButtonGroup>
    );
};

export default MassCommonButtonDropdown;
